export enum ArticleEndpoint{
  SINGLE_ARTICLE="article",
  MULTIPLE_ARTICLES="articles",
}

export enum AuthErrorCode {
  CUSTOM_MISSING_SESSION = 'custom/missing-session',
  CUSTOM_INVALID_SIGNIN_LINK = 'custom/invalid-signin-link',
  CUSTOM_PERMISSION_DENIED = 'custom/permission-denied',
  USER_DISABLED = 'auth/user-disabled',
  INVALID_ACTION_CODE = 'auth/invalid-action-code',
  EXPIRED_ACTION_CODE = 'auth/expired-action-code',
  TOO_MANY_REQUESTS = 'auth/too-many-requests',
  NETWORK_REQUEST_FAILED = 'auth/network-request-failed',
  INTERNAL_ERROR = 'auth/internal-error',
  DEFAULT = 'default',
}

export enum ArticleErrorCode {
  VIEW_ARTICLE_INVALID_ID = 'ViewArticleInvalidId',
  ARTICLE_NOT_FOUND = 'ArticleNotFound',
  VIEW_ARTICLE_INCORRECT_ID_SEPARATOR = 'ViewArticleIncorrectIdSeparator',
  VIEW_ARTICLE_TOO_MANY_IDS = 'ViewArticleTooManyIds',
  VIEW_ARTICLE_MISSING_ID_PARAM = 'ViewArticleMissingIdParameter',
  BRANDER_MISSING_REPLACEMENT_PARAM = 'BranderMissingReplacementParam',
  INVALID_REQUEST = 'InvalidRequest',
  VIEW_ARTICLE_UNKNOWN_ERROR = 'ViewArticleUnknownError',
}
